module.exports = __webpack_public_path__ + "static/media/feature_megaways.3742db62.jpg";